import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/dataServices/authDataService';
import { User } from 'src/app/models/user';
import { AppState } from 'src/app/services/app.service';
import { SecurityService } from 'src/app/services/securityService';
import { TranslateHelperService } from '../../services/TranslateService';
import { ContactInfo, SubdomainConfigService } from 'src/app/services/subdomainConfig.service';
@Component({
    selector: 'self-ins-login',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss'],
    standalone: false
})
export class LoginPageComponent implements OnInit {
    public email: string = '';
    public password: string = '';
    public isSubmit = false;
    public user: User | null = null;
    public isLoginError = false;
    public mainEmail: string = '';
    public supportEmail: string = '';

    public constructor(private router: Router,
                       private appState: AppState,
                       private securityService: SecurityService,
                       private authDataService: AuthenticationService,
                       private subdomainConfigService: SubdomainConfigService,
                       public _translateService: TranslateHelperService,) {

        const contactInfo: ContactInfo = this.subdomainConfigService.getContactInfo();
        this.mainEmail = contactInfo.email;
        this.supportEmail = contactInfo.supportEmail;
    }

    ngOnInit(): void {
        // Check if user is already authenticated
        const user = this.appState.user.getValue();
        if (user?.userSubId && user?.status === 'active') {
            // Redirect to coverage page if already authenticated
            this.router.navigate(['/coverage']);
        }
    }

    public onSubmit() {
        this.isLoginError = false;
        this.isSubmit = true;

        this.authDataService.login(this.email, this.password)
        .subscribe(
            (userData) => {
                this.securityService.setToken(userData.token);
                this.appState.updateUser(userData.identity);
                this.user = userData.identity;
                this.router.navigate(['/home']);
            },
            (_error) => {
                this.isLoginError = true;
                this.isSubmit = false;
            }
        );
    }

    public gotoHome() {
        this.router.navigate(['/coverage']);
    }
}